import React, { useEffect, useState } from 'react';
import Card from './Card';
import API_CONFIG from '../config';

const isMobile = () => window.innerWidth <= 600;

const CardsGrid = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mobile, setMobile] = useState(isMobile());

  useEffect(() => {
    fetch(API_CONFIG.CARDS_URL)
      .then(res => res.json())
      .then(data => {
        // Trier les cartes par order (comme dans SpinTV)
        const sortedCards = data.sort((a, b) => {
          const orderA = a.order !== undefined ? a.order : a.id;
          const orderB = b.order !== undefined ? b.order : b.id;
          return orderA - orderB;
        });
        setCards(sortedCards);
        setLoading(false);
      })
      .catch(error => {
        console.error('Erreur lors du chargement des cards:', error);
        setLoading(false);
      });

    const handleResize = () => setMobile(isMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) return <div className="loading">Chargement...</div>;
  if (cards.length === 0) return <div className="no-cards">Aucun bonus disponible pour le moment.</div>;

  if (mobile) {
    return (
      <div
        className="cards-grid"
        style={{
          maxWidth: 1000,
          margin: '0 auto',
          padding: '0',
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
        }}
      >
        {cards.map(card => (
          <div key={card.id} className="cards-row" style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '100%' }}>
              <Card {...card} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  const rows = [];
  let i = 0;
  while (i < cards.length) {
    if (cards[i].layout === 'full') {
      rows.push([
        <div key={cards[i].id} style={{ width: '100%' }}>
          <Card {...cards[i]} />
        </div>
      ]);
      i++;
    } else {
      const splitCards = [
        <div key={cards[i].id} style={{ flex: 1 }}>
          <Card {...cards[i]} />
        </div>
      ];
      if (cards[i + 1] && cards[i + 1].layout === 'split') {
        splitCards.push(
          <div key={cards[i + 1].id} style={{ flex: 1 }}>
            <Card {...cards[i + 1]} />
          </div>
        );
        i += 2;
      } else {
        i++;
      }
      rows.push(splitCards);
    }
  }

  return (
    <div
      className="cards-grid"
      style={{
        maxWidth: 1000,
        margin: '0 auto',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
      }}
    >
      {rows.map((row, idx) => (
        <div key={idx} className="cards-row" style={{ display: 'flex', gap: 32, width: '100%' }}>
          {row}
        </div>
      ))}
    </div>
  );
};

export default CardsGrid; 